export default "__VITE_ASSET__nkVAqjmX__"